import { render } from "./VehicleDeviationPlaceInput.vue?vue&type=template&id=34699e62"
import script from "./VehicleDeviationPlaceInput.vue?vue&type=script&lang=ts"
export * from "./VehicleDeviationPlaceInput.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
